"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var index_module_scss_1 = __importDefault(require("../../index.module.scss"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_i18next_1 = require("react-i18next");
function FeaturedCollections(_a) {
    var showModel = _a.showModel, setShowModel = _a.setShowModel;
    var words = ["Influencers", "Músicos", "Creadores", "Atletas"];
    var videos = [
        "herobg_influencers",
        "herobg_musicians",
        "herobg_creators",
        "herobg_sports",
    ];
    /*   const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [videoLoading, setVideoLoading] = useState(true); */
    /* useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((currentIndex) => (currentIndex + 1) % words.length);
        setCurrentVideoIndex(
          (currentIndex) => (currentIndex + 1) % videos.length
        );
      }, 3000);
  
      return () => {
        clearInterval(interval);
      };
    }, [currentIndex]); */
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ columns: 1 }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.hero }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: index_module_scss_1.default.overlay }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.heading }, { children: [(0, jsx_runtime_1.jsxs)("h3", { children: [(0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "starsHeaderOne" }), " ", (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "starsHeaderOneSpan" }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("h4", { children: [(0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "starsHeaderTwo" }), " "] })] }), (0, jsx_runtime_1.jsx)("button", __assign({ className: index_module_scss_1.default.button, onClick: function () { return setShowModel(!showModel); } }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "starsGetStarted" }) }))] }))] }) })) })) }));
}
exports.default = FeaturedCollections;
